const modalCreateNote = {
  header: 'הערה חדשה',
  btnCancel: 'בטל',
  btnOk: 'אוקיי',
};

export default modalCreateNote;
